import { createElement } from "react";
import { FaInstagram, FaLinkedinIn, FaXTwitter } from "react-icons/fa6";

// Use the already installed brand glyphs. React and the static generator
// render this same component; Library visitors receive only the inline SVG.
const icons = { instagram: FaInstagram, linkedin: FaLinkedinIn, x: FaXTwitter };

export function SocialIcon({ name }) {
  const Icon = icons[name];
  if (!Icon) throw new Error(`Unknown social icon: ${name}`);
  return createElement(Icon, {
    className: "kb-social-icon", size: 16,
    "aria-hidden": "true", focusable: "false",
  });
}
